module.exports = __webpack_public_path__ + "1f1b70c9e1f5c4c10d8c678eb8bd14f1.png";